import { useState } from 'react'
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom'

import { useResetPassword } from '../../hooks/queries'
import { useTexte } from '../../texte'

/**
 * Passwort vergessen -- Schritt zwei, aufgerufen über den Link aus der Mail.
 *
 * Das Passwort wird zweimal eingetippt. Ohne die Wiederholung sperrt sich
 * jemand mit einem Vertipper gerade dort aus, wo er schon nicht mehr
 * hineinkam.
 */
export function ResetPage() {
  const texte = useTexte()
  const t = texte.anmeldung
  const { token = '' } = useParams()
  const reset = useResetPassword()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [repeat, setRepeat] = useState('')

  const mismatch = repeat !== '' && password !== repeat

  if (reset.isSuccess) return <Navigate to="/" replace />

  return (
    <div className="centered">
      <form
        className="card"
        onSubmit={(event) => {
          event.preventDefault()
          if (mismatch) return
          reset.mutate({ token, password }, { onSuccess: () => navigate('/') })
        }}
      >
        <h1>{t.neuesPasswort}</h1>
        <p className="card__lead">{t.neuesPasswortLead}</p>

        {reset.isError && <p className="notice" role="alert">{reset.error.message}</p>}

        <label className="field">
          <span className="field__label">{t.neuesPasswort}</span>
          <input
            className="field__input"
            type="password"
            autoComplete="new-password"
            required
            autoFocus
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>

        <label className="field">
          <span className="field__label">{t.nochEinmal}</span>
          <input
            className="field__input"
            type="password"
            autoComplete="new-password"
            required
            value={repeat}
            onChange={(event) => setRepeat(event.target.value)}
          />
        </label>

        {mismatch && (
          <p className="notice" role="alert">{t.stimmtNichtUeberein}</p>
        )}

        <button
          className="button"
          type="submit"
          disabled={reset.isPending || mismatch}
        >
          {reset.isPending ? texte.allgemein.laeuft : t.passwortSpeichern}
        </button>

        <p style={{ marginTop: 18, textAlign: 'center', fontSize: 14 }}>
          {t.abgelaufenVor}
          <Link to="/forgot">{t.neuenAnfordern}</Link>
        </p>
      </form>
    </div>
  )
}
